// src/components/AboutContent.js
import React from 'react';
import './XrayContent.css'; // Assuming you have a CSS file for styling



const XrayContent = () => {
  return (
    <div className="dental-xray">
        <div className="dental-xray-overview-container">
            <div className="dental-xray-overview-info">
              <h2 className="dental-xray-overview-header">Dental X-Rays</h2>
              <div className="dental-xray-custom-line"></div>
              <p className="dental-xray-text">
                  Dental radiographs (x-rays) are essential, preventative, diagnostic tools that provide valuable information not visible during a regular dental exam.  Dentists and dental hygienists use this information to safely and accurately detect hidden dental abnormalities and complete an accurate treatment plan.  Without x-rays, problem areas may go undetected.
              </p>
            </div>

            <div className="dental-xray-overview-image">
              <div className="dental-xray-image-container">
                <img 
                  src="/images/xray.avif" 
                  alt="Dental Practice" 
                  className="dental-xray-1"
                />
              </div>
            </div>
        </div>
        <div className="dental-xrays-description-containers">
          <div className="xray-purpose-container">
            <h3>What Might Dental X-Rays Reveal?</h3>
            <p>Detecting and treating dental problems at an early stage can save you time, money, unnecessary discomfort, and your teeth. X-rays help us to detect the following:</p>
            <ul>
              <li>Abscesses or cysts</li>
              <li>Bone loss</li>
              <li>Cancerous or non-cancerous tumors</li>
              <li>Decay between teeth</li>
              <li>Developmental abnormalities</li>
              <li>Poor tooth or root positions</li>
              <li>Problems within tooth or below gum line</li>
            </ul>
          </div>
          <div className="xray-questions-container">
            <div className="xray-safety-container">
              <h3>Are Dental X-Rays Safe?</h3>
              <p>We are all exposed to natural radiation in our environment.  The amount of radiation exposure from a full mouth series of x-rays is equal to the amount a person receives in a single day from natural sources.</p>
              <p>Dental x-rays produce a low level of radiation and are considered safe.  Dentists take necessary precautions to limit the patient’s exposure to radiation when taking dental x-rays.  These precautions include using lead apron shields to protect the body and using modern, fast film that cuts down the exposure time of each x-ray.</p>
            </div>
            <div className="xray-scheduling-container">
              <h3>How Often Should I Get Dental X-Rays?</h3>
              <p>The need for dental x-rays depends on each patient’s individual dental health needs.  Your dentist will recommend necessary x-rays based on the review of your medical and dental history, dental exam, signs and symptoms, age consideration, and risk for disease.</p>
              <p>A full mouth series of dental x-rays is recommended for new patients.  A full series is usually good for three to five years.  Bite-wing x-rays (x-rays of top and bottom teeth biting together) are taken at recall (check-up) visits and are recommended once or twice a year to detect new dental problems.</p>
            </div>
          </div>

        </div>
    </div>
  );
};

export default XrayContent;